import React, { useState } from 'react';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import cn from 'classnames';
import { getObjectValue } from '../../utility/utills';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import OpenPopUp from '@components/Orders/OpenPopUpNewUI';
import ModalHeader from '@components/common/ModalHeader/index';
import style from './orderRevamp.module.scss';
import PropTypes from 'prop-types';

const JOB_TYPE_NAMES = {
  1: 'manager',
  2: 'server',
  3: 'bartender',
  4: 'cashier',
};

const DISCOUNT_ERROR_MESSAGES = {
  EMPTY: 'Discount cannot be empty',
  AMOUNT_INVALID: 'Discount should be more than zero and not exceed sub total',
  PERCENTAGE_INVALID: 'Discount should be more than zero and not exceed 100 %',
};

const DiscountFeature = ({
  seat,
  serverAppTheme,
  discounts,
  deviceInfo,
  userInfo,
  postDiscount,
  updateSeatInfo,
  setSeat,
  setErrorPopUp,
  loading,
  orderingPortraitOrientation
}) => {
  const [isDiscountPopUp, setIsDiscountPopUp] = useState(false);
  const [selected, setSelected] = useState('');
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);

  const hasDiscountAmount = seat?.discountAmount > 0;
  const hasDiscountInItems = seat?.orders?.[0]?.items?.some(item => item.itemType === 'D') || false;
  const hasDiscountsArray = seat?.discounts?.length > 0 || false;
  const isDiscountApplied = hasDiscountAmount || hasDiscountInItems || hasDiscountsArray;

  const getTotalAmount = table => {
    const discount = getObjectValue(() => table.discountAmount, 0);
    const serviceCharge = getObjectValue(() => table.serviceChargeAmount, 0);
    const country = JSON.parse(window.sessionStorage.getItem('auth'))?.country || 1;
    return country === 1 || country === 2
      ? +(table.itemAmount + table.taxAmount + serviceCharge - discount)
      : +(table.itemAmount - discount);
  };

  const getSubTotalAmount = table => {
    return +table.subTotalAmount;
  };

  const handleSelection = (item) => {
    if (item.open && (item.discountType === 1 || item.discountType === 2)) {
      setIsOpenPopUp(true);
    }
    setSelected(`${item.id}`);
  };

  const validate = (data) => {
    return new Promise((resolve, reject) => {
      if (!data.discount) {
        const error = new Error(DISCOUNT_ERROR_MESSAGES.EMPTY);
        error.message = DISCOUNT_ERROR_MESSAGES.EMPTY;
        reject(error);
      } else if (data.discount && discounts.find((e) => e.id === Number(selected)).discountType === 1 && (Number(data.discount) === 0 || Number(seat.subTotalAmount) < Number(data.discount))) {
        const error = new Error(DISCOUNT_ERROR_MESSAGES.AMOUNT_INVALID);
        error.message = DISCOUNT_ERROR_MESSAGES.AMOUNT_INVALID;
        reject(error);
      } else if (data.discount && discounts.find((e) => e.id === Number(selected)).discountType === 2 && (Number(data.discount) === 0 || Number(data.discount) > 100)) {
        const error = new Error(DISCOUNT_ERROR_MESSAGES.PERCENTAGE_INVALID);
        error.message = DISCOUNT_ERROR_MESSAGES.PERCENTAGE_INVALID;
        reject(error);
      } else {
        resolve();
      }
    });
  };

  const handleApplyDiscount = (data = {}) => {
    const discount = discounts.find((e) => e.id === Number(selected));
    const seatIds = seat?.seats?.filter((d) => d.open) || [];
    const discountValue = data?.discount || discount?.value || 0;
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: userInfo.id,
      checkHeaderId: seat.id,
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      discounts: [
        {
          quantity: 1,
          discountId: discount.id,
          discountName: discount.name,
          value: discountValue,
          pending: true,
          seatIds: seatIds.length > 0 ? [seatIds[0].id] : [],
          internalId: new Date().getTime(),
          modifierData: [],
          modifierJson: null
        }
      ],
      orderJson: 'ui-populated-data',
      longitude: '0',
      latitude: '0',
      geoLocation: '0'
    };

    postDiscount(dataToSend).then((res) => {
      if (res) {
        updateSeatInfo(res);

        const updatedSeat = {
          ...res,
          subTotalAmount: getSubTotalAmount(res),
          totalAmount: getTotalAmount(res),
        };

        setSeat(updatedSeat);

        setIsDiscountPopUp(false);
        setIsOpenPopUp(false);
        setSelected('');
      }
    }).catch((err) => {
      setErrorPopUp({
        res: err.message || 'Failed to apply discount',
      });
    });
  };

  return (
    <>
      <TouchableButton
        type="button"
        onClick={() => {
          if (!isDiscountApplied) {
            setIsDiscountPopUp(true);
            setSelected('');
          }
        }}
        disabled={isDiscountApplied}
        className={cn(style.borderNone, 'color-white')}
        style={{
          backgroundColor: isDiscountApplied
            ? serverAppTheme?.disabledPayBtn
            : serverAppTheme?.secondaryBtn,
          color: isDiscountApplied
            ? serverAppTheme?.btn_font_color_disabled
            : serverAppTheme?.btn_font_color,
          width: '79px',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          fontSize: '16px',
          marginRight: '0.25rem',
          flexShrink: 0,
          opacity: isDiscountApplied ? 0.6 : 1,
        }}
        rippleEffect={!isDiscountApplied}
      >
        % / {LABEL().CURRENCY_SYMBOL}
      </TouchableButton>

      {isDiscountPopUp && (
        <FullWithModal
          isOpen={isDiscountPopUp}
          isModalCenter
          customClass="h-100 w-100"
          customClass2={cn('w-100 h-100')}
          style={{
            fontFamily: 'Poppins',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            pointerEvents: 'auto',
            backgroundClip: 'padding-box',
            height: '100%',
            backgroundColor: serverAppTheme?.popUp_bg,
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow
          }}
          noBackground
          loading={loading}
        >
          <div className="w-100 h-100 justify-content-center align-items-center text-center" style={{ color: serverAppTheme?.primary_text }}>
            <ModalHeader
              isTab={seat?.tab}
              stationName={seat?.stationName}
              tileHeader={LABEL().DISCOUNT}
              seatNumber={seat?.number}
            />
            {Object.values(discounts || {}).length > 0 ? (
              <div className={cn(" m-auto  text-center overflowY overflowXHidden" , orderingPortraitOrientation ? 'col-9 fs_24 fw-400' : 'col-5 fs_22 fw-600')} style = {{top : orderingPortraitOrientation ? '15%' : ''}}>
                {(discounts).map((item) => {
                  if (item?.jobVisibility?.none) {
                    return '';
                  }
                  const visibleName = [];
                  const jobId = JOB_TYPE_NAMES[userInfo?.jobTypeId] || '';
                  Object.entries(item.jobVisibility).forEach(([key, value]) => {
                    if (key === jobId && value === true) {
                      visibleName.push(
                        <TouchableDiv
                          role="button"
                          key={item.id}
                          className={cn('card  rounded py-2  col-12 fw-400 text-center py-2' , orderingPortraitOrientation ? 'fs_24 mb-12' : 'fs_22 my-2' )}
                          onClick={(e) => {
                            e.preventDefault();
                            handleSelection(item);
                          }}
                          style={{
                            backgroundColor: selected?.includes(item.id)
                              ? serverAppTheme?.selected
                              : serverAppTheme?.unselected,
                            border: selected?.includes(item.id)
                              ? 'none'
                              : serverAppTheme.popupBorder,
                            color: selected?.includes(item.id) && 'black'
                          }}
                        >
                          {item.name}
                        </TouchableDiv>
                      );
                    }
                  });
                  return visibleName;
                })}
              </div>
            ) : (
              <div className="fs_22 fw-600 text-center px-0 py-2 h-100 overflowY overflowXHidden">
                {CUSTOM_MESSAGES().NO_DISCOUNTS}
              </div>
            )}
            <div className={cn('mx-auto d-flex',orderingPortraitOrientation ? 'fixed-bottom col-12 px-3 pb-3' : 'fixed-bottom col-8 pb-12')} style={{ paddingTop: "14px" }}>
              <div className={cn("col-6 pr-1",orderingPortraitOrientation ? 'pl-0' : '')}>
                <TouchableButton
                  type="button"
                  className={cn('px-0 rounded btn-ripple fs_24 fw-600 w-100' , orderingPortraitOrientation ? 'btn68' : 'btn44')}
                  onClick={(e) => { e.preventDefault(); setIsDiscountPopUp(!isDiscountPopUp); }}
                  style={{
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    border: serverAppTheme?.cancleBtn_Border,
                    color: serverAppTheme?.cancleBtn_font,
                  }}
                  rippleEffect={true}
                >
                  {LABEL().CANCEL}
                </TouchableButton>
              </div>
              <div className={cn("col-6 pl-1",orderingPortraitOrientation ? 'pr-0' : '')}>
                <TouchableButton
                  disabled={!selected}
                  className={cn("w-100  d-flex justify-content-center align-items-center rounded btn-ripple text-white" , orderingPortraitOrientation ? 'btn68'  : 'btn44')}
                  style={{
                    backgroundColor: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  type="button"
                  onClick={(e) => { e.preventDefault(); setIsDiscountPopUp(!isDiscountPopUp); handleApplyDiscount(); }}
                  rippleEffect={true}
                >
                  <div>{LABEL().APPLY}</div>
                </TouchableButton>
              </div>
            </div>
          </div>
        </FullWithModal>
      )}

      {isOpenPopUp && (
        <FullWithModal
          isOpen={isOpenPopUp}
          customClass="h-100 w-100"
          customClass2={cn("w-100 h-100")}
          noBackground
          style={{ fontFamily: 'Poppins', position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundColor: serverAppTheme?.popUp_bg, backgroundClip: 'padding-box', height: '100%', border: "1px solid #9F9F9F" }}
          isModalCenter
          loading={loading}
        >
          <div className="w-100 h-100 justify-content-center align-items-center text-center" style={{ color: serverAppTheme?.primary_text }}>
            <ModalHeader
              isTab={seat?.tab}
              stationName={seat?.stationName}
              tileHeader={`${LABEL().DISCOUNT_OPEN} ${discounts?.find((e) => e?.id === Number(selected))?.discountType === 1 ? `${LABEL().CURRENCY_SYMBOL}` : '%'}`}
              seatNumber={seat?.number}
            />
            <div style={{ paddingTop: '2rem' }}>
              <OpenPopUp isOpen={isOpenPopUp} discounts={discounts} validate={validate} onSubmit={handleApplyDiscount} selected={selected} setSelected={setSelected} isOpenPopUp={isOpenPopUp} setIsOpenPopUp={setIsOpenPopUp} serverAppTheme={serverAppTheme} isLandScape={true} orderingPortraitOrientation = {orderingPortraitOrientation} />
            </div>
          </div>
        </FullWithModal>
      )}
    </>
  );
};

DiscountFeature.propTypes = {
  seat: PropTypes.object,
  serverAppTheme: PropTypes.object,
  discounts: PropTypes.array,
  deviceInfo: PropTypes.object,
  userInfo: PropTypes.object,
  postDiscount: PropTypes.func,
  updateSeatInfo: PropTypes.func,
  setSeat: PropTypes.func,
  setErrorPopUp: PropTypes.func,
  loading: PropTypes.bool,
};

DiscountFeature.defaultProps = {
  seat: {},
  serverAppTheme: {},
  discounts: [],
  deviceInfo: {},
  userInfo: {},
  postDiscount: () => {},
  updateSeatInfo: () => {},
  setSeat: () => {},
  setErrorPopUp: () => {},
  loading: false,
};

export default DiscountFeature;
